import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import { goToPage } from '../cellcomEnergySlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';

const ErrorPage = (props) => {

  return (
    <div className="cellcom-energy-page-wrapper">
        <div className="cellcom-energy-page">
          <div className="gray-container">

              <div className="result-page">
                  <div className="error-icon"></div>
                  <div className="result-text-bold"> אוי לא </div>
                  <div className="result-text"> משהו השתבש והפרטים לא נשמרו </div> 
              </div>
              <div className="btn-wrapper"> <BtnSubmit text={'חזור'} onclick={handleErrorPageClick} /> </div>

          </div>
        </div>        
    </div>
  );

  function handleErrorPageClick() {
    window.location.href = Config.staticWebSiteUrl;
  }

};

const mapStateToProps = (state) => {
  return {
    page: state.cellcomEnergyBlock.page,
  };
};

const mapDispatchToProps = {
  goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);